import { create } from "zustand";
import { conceptSignature, type JamConcept } from "@/content/jam";

const STORAGE_KEY = "hippo.jamFavorites";

export interface SavedConcept {
  id: string;
  createdAt: number;
  concept: JamConcept;
}

function load(): SavedConcept[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw) as SavedConcept[];
  } catch {
    /* ignore */
  }
  return [];
}

function persist(list: SavedConcept[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
}

interface JamState {
  favorites: SavedConcept[];
  /** Returns false if an identical concept was already saved. */
  save: (concept: JamConcept) => boolean;
  remove: (id: string) => void;
}

export const useJamStore = create<JamState>((set, get) => ({
  favorites: load(),
  save: (concept) => {
    const sig = conceptSignature(concept);
    if (get().favorites.some((f) => conceptSignature(f.concept) === sig)) return false;
    const entry: SavedConcept = {
      id: `${Date.now()}-${Math.floor(Math.random() * 1e6)}`,
      createdAt: Date.now(),
      concept,
    };
    const favorites = [entry, ...get().favorites].slice(0, 100);
    persist(favorites);
    set({ favorites });
    return true;
  },
  remove: (id) => {
    const favorites = get().favorites.filter((f) => f.id !== id);
    persist(favorites);
    set({ favorites });
  },
}));
